import { Card, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import { PageBreadcrumbItem } from 'components/common/PageBreadcrumb';
import team from 'assets/img/th-each-ai/team.jpg';
import individual from 'assets/img/th-each-ai/individual.jpg';
import PromptWidget from '../../components/prompts/PromptWidgets';

const MeetingsDashboard = () => {
  const navigate = useNavigate();
  const { t } = useTranslation();

  const breadcrumbItems: PageBreadcrumbItem[] = [
    {
      label: t('Dashboard'),
      url: '/dashboard/home'
    },
    {
      label: t('Meetings'),
      active: true
    }
  ];


  return (
    <>
      <PageBreadcrumb items={breadcrumbItems} />

      <Row className="mt-3 mb-3">
        <Col sm={12} md={12} lg={12}>
          <Card className='border border-light rounded-5' >
            <Card.Body>
              <Row className=''>
                <Col md={4} lg={4}>
                  <Card style={{ height: '100%' }}>
                    <Card.Body className='bg-100'>
                      <p className="mb-0 mx-0 fs-8" style={{ 'textAlign': 'left' }}> {t("MeetingsDashboard.headline")} </p>
                    </Card.Body>
                  </Card>
                </Col>


                <Col sm={4} md={4} lg={4}>
                  <Card onClick={() => navigate(`/effective-communication/individual`)} style={{ cursor: 'pointer' }}>
                    <Card.Img variant="top" src={individual} />
                    <Card.Body className='bg-theachai-tiffany'>
                      <Card.Title className='text-white m-0 p-0 fs-7'>{t("MeetingsDashboard.individual_meetings")}</Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
                <Col sm={4} md={4} lg={4}>
                  <Card onClick={() => navigate(`/effective-communication/team`)} style={{ cursor: 'pointer' }}>
                    <Card.Img variant="top" src={team} />
                    <Card.Body className='bg-theachai-dark-blue'>
                      <Card.Title className='text-white m-0 p-0 fs-7'>{t("MeetingsDashboard.group_meetings")}</Card.Title>
                    </Card.Body>
                  </Card>
                </Col>
              </Row>
            </Card.Body>
          </Card>
        </Col>
      </Row>

      <Row className="mt-3 mb-3">
        <Col sm={12} md={12} lg={12}>
          <Card className='border border-light rounded-5' >
            <Card.Body>
              <p className="mb-0 mx-0 fs-8" style={{ 'textAlign': 'left' }}> {t("MeetingsDashboard.headline2")}</p>
              <p className="mt-0 mx-0 fs-8" style={{ 'textAlign': 'left' }}> {t("MeetingsDashboard.headline3")}</p>
            </Card.Body>
          </Card>
        </Col>
      </Row>


      <PromptWidget page="meetings" />

    </>
  );
};

export default MeetingsDashboard;
